import { createFileRoute } from '@tanstack/react-router'
import TimetableTest from '../../components/teacherPage/TimetableTest'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/teacher/timetable-test')({
  component: TimetableTestPage,
})

function TimetableTestPage() {
  const { t } = useTranslation()
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-6">
        {t('routes.teacher-folder.timetableTest.title')}
      </h1>
      <TimetableTest />
    </div>
  )
}
